let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lMJXb")).then(() => parcelRequire('1H3yD'));